import { render, staticRenderFns } from "./historicoJob.vue?vue&type=template&id=5695dcde&scoped=true&"
import script from "./historicoJob.vue?vue&type=script&lang=js&"
export * from "./historicoJob.vue?vue&type=script&lang=js&"
import style0 from "./historicoJob.vue?vue&type=style&index=0&id=5695dcde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5695dcde",
  null
  
)

export default component.exports